<template>
  <v-card
    :class="[
      'foldable-card',
      closable && 'closable',
      hideBorder && 'hide-border'
    ]"
  >
    <loading-overlay :value="loading" />

    <slot v-if="noHeader">{{ noData }}</slot>
    <template v-else>
      <v-card-title class="card-title padding-x">
        <h3 class="font-weight-bold">{{ title }}</h3>
        <v-spacer></v-spacer>

        <v-btn v-if="!nonFoldable" icon @click="show = !show">
          <v-icon class="collapse-icon" color="secondary"
            >{{ show ? "mdi-chevron-down" : "mdi-chevron-up" }}
          </v-icon>
        </v-btn>

        <v-btn
          class="mr-n2"
          v-else-if="closable"
          icon
          @click="$emit('closing')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-slide-y-transition>
        <v-card-text
          :class="['padding-x pb-8', reducePadding1 && 'no-padding-x']"
          v-show="show"
        >
          <div class="header">
            <v-divider v-if="!disableHeaderDivider"></v-divider>
            <p class="mt-1 mb-0 description-wrapper">
              <span v-if="description"> {{ description }} </span>
              <slot name="description" v-else></slot>
            </p>
          </div>
          <div class="main-content-wrapper">
            <slot>{{ noData }}</slot>
          </div>
        </v-card-text>
      </v-slide-y-transition>
    </template>
  </v-card>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay";

const noData = "No data to display";

export default {
  name: "FoldableCard",
  props: {
    title: String,
    description: String,
    nonFoldable: Boolean,
    hideBorder: Boolean,
    loading: Boolean,
    reducePadding1: {
      type: Boolean,
      default: false
    },
    disableHeaderDivider: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: true,
    noData
  }),
  computed: {
    closable() {
      return this.$listeners && this.$listeners.closing;
    },
    noHeader() {
      return !this.title && !this.description && !this.$slots.description;
    }
  },
  methods: {},
  components: {
    LoadingOverlay
  }
};
</script>

<style lang="sass" scoped>

.foldable-card.v-card
  border-top: 6px solid $color-pt-royal-25
  // Note: changing this from hidden to visible for VP-2409 dropdown, if it causes issue in other pages that uses foldable-card, we'll apply it conditionally
  overflow: visible

  &.hide-border
    border-top: none
  // overrides default 4px from vuetify
  border-radius: 2px !important
  box-shadow: 0 4px 10px 0 $dark-grey
  position: relative

  .card-title
    height: 3.5rem
    color: $grey-text-color

  h3
    font-size: 1.25rem

  &.closable .card-title
    height: 3.875rem

  .description-wrapper
    color: $grey-text-color2

  .padding-x
    padding: 0 40px

  .no-padding-x
    padding-left: 0
    padding-right: 0

  &.closable .padding-x
    padding: 0 24px

  .v-divider
    border-color: $light-grey

  .main-content-wrapper
    margin-top: 2rem
    padding: 0 1rem

  &.closable .main-content-wrapper
    margin-top: 1.875rem
    padding: 0
</style>
